<template>
    <v-container fluid>
        <v-card
            width="380"
            class="mx-auto pb-4"
            elevation="2"
            outlined
        >
            <v-card-title
                class="secondary--text primary"
            >
                Set / Update Current Term
            </v-card-title>
            <v-card-text
                class="pt-6"
            >
                <v-combobox
                    label="Academic Year"                    
                    :items="academicYear"
                    text="text"
                    value="value"
                    v-model="selectedYear"
                    @change="getNewTermBeginning"
                ></v-combobox>

                <v-select
                    label="Term"                    
                    :items="terms"
                    item-text="title"
                    item-value="id"
                    v-model="selectedTerm"
                    @change="getNewTermBeginning"
                ></v-select>
                
                <v-text-field
                    label="Possible Attendance"
                    v-model="possibleAttendance"
                    type="number"
                    class=""
                ></v-text-field> 
                
                <v-menu
                    ref="menuCurrentTermStart"
                    v-model="menuCurrentTermStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"                   
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field                        
                        :value="formattedCurrentTermStart"
                        label="Term Start"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    ref="picker"
                    v-model="currentTermStart"
                    
                    min="1950-01-01"
                    @change="saveCurrentTermStart"
                    ></v-date-picker>
                </v-menu>

                <v-menu
                    ref="menuCurrentTermEnd"
                    v-model="menuCurrentTermEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"                   
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field                        
                        :value="formattedCurrentTermEnd"
                        label="Term End"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    ref="picker"
                    v-model="currentTermEnd"
                    
                    min="1950-01-01"
                    @change="saveCurrentTermEnd"
                    ></v-date-picker>
                </v-menu>

                <v-menu
                    ref="menuNewTermBeginning"
                    v-model="menuNewTermBeginning"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"                   
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field                        
                        :value="formattedNewTermBeginning"
                        label="New Term Beginning"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    ref="picker"
                    v-model="newTermBeginning"
                    
                    min="1950-01-01"
                    @change="saveNewTermBeginning"
                    ></v-date-picker>
                </v-menu>
                
            </v-card-text>

            <v-card-actions>
                <v-btn
                    color="primary"
                    @click="registerStudentsMenu"
                    outlined                
                >
                    Register Students
                </v-btn>                
                <v-btn
                    color="primary"
                    dark
                    outlined
                    @click="setTerm"                    
                >
                    Set / Update Term
                </v-btn>
            </v-card-actions>

            <v-overlay
                :absolute="absolute"
                :value="overlay"
                opacity="0.5"
                color="#A0A0A0"
            >
                <v-card
                    light
                    class="pa-4"
                    max-width="350"
                >
                    <v-card-text>
                        <v-autocomplete
                            v-model="selectedFormClass"
                            :items="formClasses"
                            chips
                            deletable-chips
                            label="Select Class"
                            item-text="id"
                            item-value="id"
                            hide-details
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                    <span v-if="data.item.id === 'All'">{{ data.item.id }}</span>
                                    <span v-else>{{ data.item.id }} </span>
                                </v-chip>
                            </template>

                            <template v-slot:item="data">
                                {{ data.item.id }} 
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="pa-0">
                        <v-btn
                            color="primary"
                            outlined
                            @click="overlay = !overlay"
                            class="flex-grow-1"
                        >
                            Cancel
                        </v-btn>                        
                        <v-btn
                            dark
                            color="primary"                           
                            @click="registerStudents"
                        >
                            Register Students
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-overlay>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { format, parseISO } from 'date-fns';

export default {
    name: 'AdminDashboard',
    mounted: function () {
        this.initialize();
    },
    
    computed: {
        formattedNewTermBeginning () {
            return this.newTermBeginning ? format(parseISO(this.newTermBeginning), 'dd-MMM-yyyy') : '';
        },

        formattedCurrentTermStart () {
            return this.currentTermStart ? format(parseISO(this.currentTermStart), 'dd-MMM-yyyy') : '';
        },

        formattedCurrentTermEnd () {
            return this.currentTermEnd ? format(parseISO(this.currentTermEnd), 'dd-MMM-yyyy') : ''; 
        },        

        ...mapGetters({
            progressOverlay: 'admin/getProgressOverlay',  
            userAdmin: 'admin/getUserAdmin',          
        })
    },

    data: () => ({
        academicYear: [],            
        terms: [],
        termArchives: [],
        selectedYear: '',
        selectedTerm: '',
        possibleAttendance: '',
        newTermBeginning: null,
        currentTermStart: null,
        currentTermEnd: null,
        date: null,
        menuCurrentTermStart: false,
        menuCurrentTermEnd: false,
        menuNewTermBeginning: false,
        overlay: false,
        absolute: true,
        selectedFormClass: 'All',
        formClasses: [],   
    }),

    watch: {
        menu (val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        }
    },
    
    methods: {        
        ...mapMutations({
            setModal: 'admin/setModal',
            setModalTitle: 'admin/setModalTitle',
            setModalMessage: 'admin/setModalMessage',
            setModalIcon: 'admin/setModalIcon',
            setOverlay: 'admin/setProgressOverlay',
            setAcademicTerm: 'admin/setAcademicTerm',
            setAcademicYearId: 'admin/setAcademicYearId',            
            setFormClassSelected: 'admin/setSelectedFormClass',
            setTermRegistrationProgress: 'admin/setTermRegistrationProgress',
        }),

        ...mapActions({            
            register: 'admin/registerStudents',
            setCurrentAcademicTerm: 'admin/setCurrentAcademicTerm',
            getCurrentAcademicTerm: 'admin/getCurrentAcademicTerm',
            getFormClasses: 'admin/getFormClasses',
            getAcademicYears: 'admin/getAcademicYears',
            clearFlags: 'admin/clearFlags',
        }),

        async initialize () {
            this.academicYear = [];
            this.setOverlay(true);
            try {
                
                const [
                    { data: dataTerm },
                    { data: dataYears },
                    { data: dataClasses },
                ] =
                await Promise.all([
                    this.getCurrentAcademicTerm(), 
                    this.getAcademicYears(),
                    this.getFormClasses(),
                ]);
                
                const { terms, current_term, terms_archive } = dataTerm;
                this.terms = terms;
                this.termArchives = terms_archive;
                this.setAcademicPeriod(current_term);
                this.setAcademicYears(dataYears);
                this.setFormClasses(dataClasses);
                
            } catch (error) {
                if(error.response) console.log(error.response)
                else console.log(error);
            }

            this.setOverlay(false);
        },

        setAcademicYears (data) {
            let maxYear = 0;
            let yearStart = 0;
            let yearEnd = 0;
            if(data.length === 0) return;
            data.forEach(({ id }) => {
                yearStart = id.toString().substring(0,4);
                yearEnd = id.toString().substring(4)
                this.academicYear.push(
                    yearStart + '-' + yearEnd
                )
                if(yearEnd > maxYear){
                    maxYear = yearEnd;
                }
            })
            this.academicYear.unshift(
                maxYear + '-' + (parseInt(maxYear)+1)
            )
        },
        
        setAcademicPeriod (current_term) {
            let academicYear = current_term.academic_year_id.toString();
            this.selectedYear = academicYear.substring(0,4) + '-' + academicYear.substring(4);
            this.selectedTerm = current_term.term;
            this.possibleAttendance = current_term.possible_attendance;
            this.newTermBeginning = current_term.new_term_beginning;
            this.currentTermStart = current_term.date_start;
            this.currentTermEnd = current_term.date_end;
            this.setAcademicYearId(current_term.academic_year_id);
        },

        setFormClasses (data) {
            this.formClasses.push({ id: 'All'});
            data.forEach(value => {
                if(value.form_level)
                this.formClasses.push(value);
            });
            // console.log(this.formClasses);
        },

        async registerStudents(){            
            if(this.selectedFormClass != 'All')
            this.setFormClassSelected(this.selectedFormClass);

            if(!this.selectedYear || !this.selectedTerm){
                this.setModal(true);
                this.setModalTitle('Error');
                this.setModalMessage('Please set the Academic Year and Term to continue.');
                this.setModalIcon('error');
                return;
            }

            this.overlay = false;
            this.setOverlay(true);
            this.$emit('progress-type', 'linear');
            await this.clearFlags();
            this.postTermRegistration();               
            
        },

        async postTermRegistration () {
            
            this.register().then(response => {                
                let rows_processed = response.data.rows_processed;
                let rows_total = response.data.total_rows;               
                this.setTermRegistrationProgress((rows_processed / rows_total) * 100);
                
                if(response.data.rows_processed != response.data.total_rows)
                this.postTermRegistration();
                else{                    
                    this.setOverlay(false);
                    this.setModal(true);
                    this.setModalTitle('');
                    this.setModalMessage('Students Registered Successfully.');
                    this.setModalIcon('success');
                    this.setTermRegistrationProgress(0);
                }
            }).catch(error => {
                this.setOverlay(false);
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setModal(true);
                this.setModalTitle('Error');
                this.setModalMessage('An Error has Occurred. Please contact Admin.');
                this.setModalIcon('error');
            })
        },

        saveNewTermBeginning(date){
            this.$refs.menuNewTermBeginning.save(date)
        },

        saveCurrentTermStart(date){
            this.$refs.menuCurrentTermStart.save(date)
        },
        
        saveCurrentTermEnd(date){
            this.$refs.menuCurrentTermEnd.save(date)
        },

        async setTerm(){
            if(this.selectedYear && this.selectedTerm) {
                console.log('setting term');
                let academicyear = this.selectedYear.replace(/\s+/g, '');            
                let academicYearId = academicyear.replace('-', '');
                //let year = academicYearId.substring(0,4);
                
                let academicTerm = {
                    term: this.selectedTerm,
                    new_term_beginning: this.newTermBeginning,
                    date_start: this.currentTermStart,
                    date_end: this.currentTermEnd,
                    possible_attendance: this. possibleAttendance,
                    academic_year_id: academicYearId,
                    is_current: 1
                }
                this.setAcademicTerm(academicTerm);
                try {
                    await this.setCurrentAcademicTerm(academicTerm);

                    await this.initialize();
                    
                    this.setModal(true);
                    this.setModalTitle('');
                    this.setModalMessage('Term Set Successfully.')
                    this.setModalIcon('success')
                    
                } catch (error) {
                    if(error.response) console.log(error.response)
                    else console.log(error);
                    this.setModal(true);
                    this.setModalTitle('Error');
                    this.setModalMessage(error);
                    this.setModalIcon('error');
                }
                
            }
            else{
                this.setModal(true);
                this.setModalTitle('Error');
                this.setModalMessage('Please set the Academic Year and Term to continue.');
                this.setModalIcon('error');
            }
        },

        registerStudentsMenu () {
            this.overlay = true;
        },

        getNewTermBeginning () {
            let academicyear = this.selectedYear.replace(/\s+/g, '');            
            let academicYearId = academicyear.replace('-', '');
            this.termArchives.forEach(record => {
                if(
                    record.academic_year_id == academicYearId &&
                    record.term == this.selectedTerm
                ){
                    this.date = record.new_term_beginning;
                }
            })
        },

        remove (item) {
            console.log(item)
            const index = this.formClasses.findIndex(formClass => formClass.id === item.id);
            console.log(`index: ${index}`)
            if(index >= 0) this.formClasses.splice(index, 1);
        }
    }
}
</script>